import { Mapper, AppMapperError } from 'module/Common';
import { Category } from './Category';
import find from 'lodash-es/find';
import filter from 'lodash-es/filter';

export { Category } from './Category';

export type Categories = Array<Category>;

export namespace Categories {
  export const mapper = Mapper.errorWrapper(
    err => new AppMapperError('Categories', err),
    Mapper.arrayOrEmptyIfNull(Category.mapper)
  );

  export const findById = (categories: Categories, id: number) => {
    return find(categories, cat => {
      return Category.getId(cat) === id;
    });
  };

  export const findByIds = (categories: Categories, ids: Array<number>): Categories => {
    return ids.map(id => findById(categories, id)).filter<Category>((v): v is Category => v !== undefined);
  };

  export const filterByKind = (categories: Categories, type: Category.CategoryKind) => {
    return filter(categories, cat => {
      return Category.getKind(cat) === type;
    });
  };

  export const filterBasics = (categories: Categories) => {
    return filterByKind(categories, Category.CategoryKind.Basic);
  };

  export const filterClients = (categories: Categories) => {
    return filterByKind(categories, Category.CategoryKind.Client);
  };
}



// WEBPACK FOOTER //
// ./src/module/Model/Categories/Categories.ts